import { WebPlugin } from '@capacitor/core';
import html2canvas from 'html2canvas';
export class ScreenshotWeb extends WebPlugin {
    async take() {
        const canvas = await html2canvas(document.body);
        return { uri: canvas.toDataURL() };
    }
}
//# sourceMappingURL=web.js.map